import React from "react";
import { Params, useLocation, useNavigate, useParams } from "react-router-dom";
import { http } from "../Common/http";
import { useAuth } from "../Auth/Auth";
import { Button, Result, Spin } from "antd";
import { Content } from "antd/lib/layout/layout";
import { ScoringData } from "../FU-45/ScoringPage";
import ScoringWrittenPage from "../FU-45/ScoringWrittenPage";
import ScoringInterviewPage from "../FU-45/ScoringInterviewPage";
import { Messages } from "../Common/ValidateMessages";

export const ScoringResultViewPage = () => {
  const { accessToken } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { examSubjectId, objectId } = useParams<Readonly<Params<string>>>();
  const [loading, setLoading] = React.useState(true);
  const [loadError, setLoadError] = React.useState(false);
  const [scoringData, setScoringData] = React.useState<ScoringData>();
  const loadData = async () => {
    try {
      setLoading(true);
      const result = await http<ScoringData, any>({
        path: "/Scoring/getviewdata",
        method: "post",
        body: {
          examSubjectId: examSubjectId,
          objectId: objectId,
          useCase: "4",
        },
        accessToken: accessToken,
      });

      if (result.ok && result.body) {
        setScoringData(result.body);
        setLoadError(false);
      } else {
        setLoadError(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setLoadError(true);
    }
  };
  const backToBeforePage = () => {
    navigate("/PreparatoryStudentList", { state: state });
  };

  React.useEffect(() => {
    const doLoadData = async () => {
      await loadData();
    };
    doLoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <Content>
      <Spin spinning={true} />
    </Content>
  ) : loadError ? (
    <Content>
      <Result
        status="500"
        title="エラーが発生しました"
        subTitle={Messages["ERR-046"]}
        extra={
          <Button
            size="large"
            type="primary"
            onClick={() => backToBeforePage()}
          >
            志願者一覧に戻る
          </Button>
        }
      />
    </Content>
  ) : scoringData?.scoringType === "1" ? (
    <ScoringWrittenPage
      objectId={objectId!}
      useCase={"4"}
      scoringType={"1"}
      scoringData={scoringData}
      backToBeforePage={backToBeforePage}
      // evaluations={dummyEvaluations}
      // applicants={[dummyApplicants[0]]}
    />
  ) : (
    <ScoringInterviewPage
      objectId={objectId!}
      useCase={"4"}
      scoringType={"2"}
      scoringData={scoringData}
      backToBeforePage={backToBeforePage}
      // evaluations={dummyEvaluations}
      // applicants={dummyApplicants}
    />
  );
};
